/**
 * Resolve where MSAL should land after interactive login (D37).
 * Prefer `?return=` (same-origin path) so a real auth-death redirect
 * returns the operator to the same conversation — never dump to blank `/`
 * when a return target was provided.
 */
export function resolvePostLoginRedirectStartPage(
  search: string = typeof window !== 'undefined' ? window.location.search : '',
  origin: string = typeof window !== 'undefined' ? window.location.origin : ''
): string {
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  const raw = params.get('return');
  if (raw) {
    try {
      const decoded = decodeURIComponent(raw);
      if (decoded.startsWith('/') && !decoded.startsWith('//')) {
        return `${origin}${decoded}`;
      }
      if (origin && decoded.startsWith(origin)) {
        return decoded;
      }
    } catch {
      // fall through
    }
  }
  return `${origin}/`;
}
